import React, { useState } from 'react';
import { ChevronDown, ChevronUp, HelpCircle } from 'lucide-react';
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const faqs = [{
    q: '¿Cómo recibo el material?',
    a: 'Recibís acceso inmediato apenas se confirma el pago. Te llega un correo con el enlace de descarga y todo el contenido queda disponible para ver y descargar las veces que necesites.'
  }, {
    q: '¿Puedo verlo desde el celular?',
    a: 'Sí. El material está optimizado para verse desde celular, tablet y computadora. Lo podés revisar en el campo o desde tu casa sin problemas.'
  }, {
    q: '¿Necesito experiencia previa para usarlo?',
    a: 'No. El sistema es visual, práctico y fácil de entender. Está pensado para productores que quieren resultados, no tecnicismos. Solo necesitás ganas de mejorar tu manejo.'
  }, {
    q: '¿Los diseños se pueden adaptar a mi campo?',
    a: 'Sí. Podés ajustar las ideas y configuraciones según tu producción, el tamaño de tu hacienda y el espacio disponible. Hay 75 diseños para que elijas el que mejor se adapte a tu realidad.'
  }, {
    q: '¿Sirve para pocos animales o solo para grandes establecimientos?',
    a: 'Sirve para ambos. Hay diseños pensados para pequeños productores, establecimientos medianos y sistemas más intensivos. El Bonus 4 incluye específicamente diseños adaptables para diferentes producciones.'
  }, {
    q: '¿Cuánto cuesta construir uno de estos corrales?',
    a: 'Depende del diseño y los materiales que elijas. El sistema te ayuda a planificar antes de gastar, así evitás errores costosos. Muchos productores recuperan la inversión solo con los materiales que dejan de desperdiciar.'
  }, {
    q: '¿Tiene garantía si no me convence?',
    a: 'Sí. Tenés 7 días para revisar todo el sistema. Si no te ayuda a mejorar la organización y el manejo de tu campo, te devolvemos el 100% del dinero. Sin formularios ni vueltas.'
  }, {
    q: '¿Hay que pagar una mensualidad o suscripción?',
    a: 'No. Es un pago único. Comprás una vez y el material queda tuyo para siempre. Sin renovaciones ni cargos ocultos.'
  }, {
    q: '¿Qué diferencia hay entre la Opción Base y el Pack Premium?',
    a: 'La Opción Base incluye los 75 diseños y los 4 bonos. El Pack Premium incluye todo lo anterior más la Guía Premium de Manejo Ganadero Eficiente, pensada para llevar la organización y productividad a otro nivel.'
  }, {
    q: '¿Puedo imprimir los planos para usarlos en el campo?',
    a: 'Sí. Todo el material está pensado para imprimirse y trabajar con los planos en mano. Llevalos al terreno, marcá medidas y ajustalos según vayas avanzando.'
  }];
  return <section className="py-10 md:py-14 px-4 bg-black" data-id="element-54">
      <div className="max-w-3xl mx-auto" data-id="element-55">
        <div className="text-center mb-8" data-id="element-56">
          <div className="inline-flex items-center gap-1.5 bg-brand-green text-white font-bold px-3.5 py-1 rounded-full mb-3 uppercase tracking-wider text-[11px] md:text-xs shadow-md" data-id="element-57">
            <HelpCircle className="w-3.5 h-3.5" data-id="element-58" /> Preguntas Frecuentes
          </div>
          <h2 className="text-2xl md:text-4xl font-display font-bold text-white uppercase leading-tight" data-id="element-59">
            ❓ Lo Que Más <span className="highlight-green" data-id="element-60">Nos Preguntan</span>
          </h2>
        </div>

        <div className="space-y-2.5" data-id="element-61">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <div key={index} className={`bg-zinc-900 rounded-lg border-2 overflow-hidden transition-all duration-200 ${isOpen ? 'border-brand-green shadow-lg' : 'border-brand-green/20 shadow hover:border-brand-green/60'}`} data-id="element-62">
                <button className="w-full px-4 py-3 md:px-5 md:py-4 text-left flex justify-between items-center gap-2.5 focus:outline-none" onClick={() => setOpenIndex(isOpen ? null : index)} data-id="element-63">
                  <span className={`font-display font-bold text-sm md:text-base pr-1 leading-tight ${isOpen ? 'text-brand-greenLight' : 'text-white'}`} data-id="element-64">
                    {faq.q}
                  </span>
                  <div className={`shrink-0 w-7 h-7 md:w-8 md:h-8 rounded-full flex items-center justify-center transition-colors ${isOpen ? 'bg-brand-green text-white' : 'bg-zinc-800 text-brand-greenLight'}`} data-id="element-65">
                    {isOpen ? <ChevronUp className="w-4 h-4" data-id="element-66" /> : <ChevronDown className="w-4 h-4" data-id="element-67" />}
                  </div>
                </button>

                <div className={`overflow-hidden transition-all duration-300 ease-in-out ${isOpen ? 'max-h-96 pb-4 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-68">
                  <div className="px-4 md:px-5 pt-1.5 border-t border-brand-green/30" data-id="element-69">
                    <p className="text-xs md:text-sm text-zinc-300 leading-relaxed pt-2.5" data-id="element-70">
                      {faq.a}
                    </p>
                  </div>
                </div>
              </div>;
        })}
        </div>
      </div>
    </section>;
}